import React, { memo } from 'react';
import { Tooltip, Icon, colors } from '@dexma/ui-components';
import { StyledAlertWarning } from 'adapter/in/dashboards/components/SmallAlertTooltip/style';
import i18n from 'asset/translation';

type SmallAlertTooltipProps = {
    tooltipMessage: string;
};

const SmallAlertTooltip = memo((props: SmallAlertTooltipProps) => {
    const { tooltipMessage } = props;
    return (
        <StyledAlertWarning data-testid='small-alert-tooltip'>
            <Tooltip title={tooltipMessage}>
                <Icon color={colors.gray800} name='warning' ariaLabel={i18n.t('dashboards.edit.ariaLabel.widgetAlert')} />
            </Tooltip>
        </StyledAlertWarning>
    );
});

export default SmallAlertTooltip;
